<template>
    <div class="modal-container has-text-centered" style="overflow: auto">
        <button id="saveButtTop" class="button is-small is-coolGreen" style="position: absolute; left: 13px; top: 13px"   @click="save($event)">SAVE</button>
         <div id="xButt" class="delete is-pulled-right top10" @click="cancel"></div>
         
        <div class="has-text-dark  bottom20">
            
           <div class="top40"> <div class="is-size-4"><img src="@/assets/img/fourDotsLogo.png" width="18"/>
           <span class="left3 has-text-white left10">{{createOrEdit == 'create' ? 'NEW' : 'EDIT'}} {{sub ? 'SUB' : ''}} BUNDLE</span></div></div>
            <br>
            <!-- <div  ref="bName" class="editCardTitle is-size-5 has-text-left title" contenteditable="true" @keydown.enter="save($event)" @keydown="restrictLength($event)"  v-text="bundleName"></div> -->
            <input id="v-step-3" ref="bName" type="text" class="input" placeholder="BUNDLE NAME" v-model="bundleName" />
            <div v-show="showPlaceholder" class="has-text-left" style="margin: 0 50px 0 55px; position: relative; top: 3px; color: #888">Name</div>
            
            <div v-if="!collabId && createOrEdit != 'edit' && !$parent.dispUrl" class="has-text-white top20">
                <input type="checkbox" id="collabCheckBox" :class=" {disabledCheckbox: $root.app.userAttrs.bundleLimit > 0 && $root.app.checkLimits}"  @click="checkInApp"/> 
                &nbsp;<span :class="{disabledCheckbox: $root.app.userAttrs.bundleLimit > 0 && $root.app.checkLimits}" >Is Collaborative</span><br>
                <span v-show="showCollabAlert">To enable this functionality please visit your account settings from a web browser.</span>
            </div>

            <div v-if="isCollab">
                <!-- <div v-show="!newGroup">
                    <div v-show="inView == 0 || inView == 1" class="has-text-white">
                        <div class="top10">Assign to Group:</div>
                        <select class="select" ref="dropdown" v-model="collabId">
                            <option value="-1" selected>Select...</option>
                            <option v-for="(item, i) in groups" :key="i" :value="item.id">{{item.name}}</option>
                        </select><br>
                        <div class="is-size-7 isUnderlined handCursor" @click="doNewGroup">+New Group</div>
                      
                    </div>
            
                <div v-show="inView == 4">
                    <div>Group Members have been Notified</div>
                </div> 
                
                   
                </div>-->
    
    
                <div v-if="newGroup" class="top20">
                   <!--  <div class="has-text-white top10"><b>Create New Group</b></div>
                    <div class="has-text-white">Name:</div>
                    <input type="text" class="input top5" style="width: 200px" ref="gNameInput"/>
                    <div class="has-text-danger is-size-6">{{err}}</div> -->
                    <div class="top5 has-text-white"><b>Invite Members:</b></div>
                    <div v-if="connects.length" class="has-background-grey groupConnectChooser marginAutod has-text-left pad10 roundedCorners" id="memberList">
                        <div v-for="(item, index) in connects" :key="index" ref="groupMembers" :ci="item.id">
                            <input type="checkbox" class="checkbox"/> 
                            <span class="has-text-white" v-if="item.id_recip == true && item.meOrig">&nbsp;{{item.fName + ' ' + item.lName}}</span>
                            <span class="has-text-white" v-if="!item.meOrig">&nbsp;{{item.origF + ' ' + item.origL}}</span>
                        </div>
                    </div>
                    <div v-if="connects.length == 0" class="has-text-white pad10">You can add people you are connected with. Go to the <b class="has-text-coolGreen" @click="$router.push('/connects')">Collab Network</b> section to others. Once connected they will show up here.</div>
                    <!-- <div class="top10"><button class="button is-small is-coolGreen" @click="createGroup">Create</button>&nbsp;<button class="button is-small" @click="cancelGroup">Cancel</button></div> -->
                    <br>
                </div>
        </div>

        <!-- TREE -->
        
        <div v-if="!$parent.newModalHideTree" class="has-text-left top20">
            <div class="has-text-white has-text-centered"><b>Location:</b></div>
             <div class="roundedCorners2 marginAutod">
                <div class="has-background-dark">&nbsp;<span class="is-inline-block top2"><b>&nbsp;save into:</b>&nbsp;</span>
                <input @change="bundleFilter" type="text" class="is-pulled-right azTextInput right1 " style="width: 100px" v-model="bundleSearchTerm"/>
                <i class="is-pulled-right top3 right5 has-text-light is-size-7">filter:</i></div>
                <div class="treeView has-background-dark" style="height: 320px;">
                    <tree-4-bundles ref="node" v-for="(item, index) in filteredTreeNoInbox" 
                            :key="index" 
                            :listName="item.listName" 
                            :children="item.children" 
                            :depth="0" 
                            :id="item.id" 
                            :aliasTgtId="item.aliasTgtId" 
                            :hideMe="item.hideMe"
                            :isCollab="item.isCollab"
                            >
                    </tree-4-bundles>
                    <br>
                </div>
            </div>
        </div>

        </div>
        <button id="v-step-4" class="button is-small top10 is-coolGreen wideButton" @click="save($event)">SAVE</button><br>
        <div class="cancelButton  top10" @click="cancel">Cancel</div>
         <div v-if="createOrEdit == 'edit'" class="top10 has-text-centered">
            <div v-if="!sure" class="cancelButton has-text-grey" @click="sure = true">{{collabId && calcMembers.length > 1 && caller.data.isRoot ? 'Leave Collab' : 'Delete'}}</div>
            <span v-if="sure" class="has-text-white is-size-7"><b>Are you sure? </b>&nbsp;<button class="button is-coolGreen tiny" @click="deleteBundle">YES</button>&nbsp;<button class="button tiny" @click="sure = false">NO</button></span>
        </div>
        <div>&nbsp;</div>
    </div>
</template>

<script>

import { AZEventBus } from '../components/AZEventBus'
import Tree4Bundles from '../components/Tree4Bundles'

export default{
    components: {Tree4Bundles},
    props: {
        callBack: {
            type: Function
        },
        callBack2: {
            type: Function
        },
        bundleName: {
            type: String,
            default: ''
        },
        createOrEdit: {
            type: String, 
            default: 'create'
        },
        sub: {
            type: Boolean,
            default: true
        },
        bundleId: {
            type: Number,
            default: -1
        },
        collabId: {
            type: Number,
            default: null
        },
        bParent: {
            type: Number,
            default: null
        },
        aliasTgtId: {
            type: Number,
            default: null
        },
        selectedId: {
            type: Number,
            default: 0
        },
        selectedAliasId: {
            type: Number,
            default: 0
        },
        me: {
            type: Number,
            default: null
        },
        caller: {
            type: Object
        },

    },
    data: function(){
       return {
            sure: false,
            groups: [],
            inView: 0,
            newGroup: true,
            connects: [],
            err: '',
            isCollab: false,
            tempCollabId: null,
            showPlaceholder: false,
            bundleSearchTerm: '',
            selectedCollabId: null,
            doChangeParent: false,
            showCollabAlert: false

       }
    },
    mounted: function(){
        this.$refs.bName.focus()

     


        let self = this

            function w(d){
                az.addRemSpinner(false, 'id', 'memberList')
                
                let a = d.r.filter(e => {
                    return e.active == 1
                })

                a.sort()
                self.connects = a

            }

            function n(){
                az.addRemSpinner(false, 'id', 'memberList')
            }

            if(!this.$parent.newModalHideTree){
                az.addRemSpinner(true, 'id', 'memberList')
                this.$root.app.apiClient.get('subs/conn/', {}, w, n)
            }
          

        AZEventBus.$on('onTreeNodeClicked', this.onTreeNodeClickedHandler);

        function autoSel(arr, id){
            if(!arr)
                return

            arr.forEach(e => {
                if(e.id == self.selectedId){
                    e.isSelected = true
                    e.$refs.cb.checked = true

                    let br = []
                    let c = e
                    br.push(e.id)
                    for(var x = e.depth; x > 1; x--){
                        br.push(c.$parent.id)
                        c = c.$parent
                    }

                    AZEventBus.$emit('filteredBundles', br)

                } else {
                    e.isSelected = false
                    if(e.$refs.cb)
                        e.$refs.cb.checked = false
                }

                if(e.id == self.me){
                    e.hideMe = true
                }


                if(e.children.length){
                    autoSel(e.$refs.node)
                }
                
            })
        }

        autoSel(self.$refs.node)

        if(self.selectedId == 0){
            self.$refs.node[0].isSelected = true;
            self.$refs.node[0].$refs.cb.checked = true;
        } 
       
    },

    beforeDestroy: function(){
        AZEventBus.$off('onTreeNodeClicked', this.onTreeNodeClickedHandler)
    },

    methods:{

        onTreeNodeClickedHandler(msg){
            var self = this // was pasted from other scope that was deeper than "this"

            self.doChangeParent = true
            self.selectedId = msg.wrapperId
            self.selectedAliasId = msg.aliasTgtId
            self.selectedCollabId = msg.collabId
            //Remove all selections
            function clear(arr){
                if(!arr)
                     return
                arr.forEach(e => {
                    if(!e.hideMe){
                        if(e.id == msg.wrapperId){
                            e.isSelected = true
                            if(e.$refs.cb)
                                e.$refs.cb.checked = true
                        } else {
                            e.isSelected = false
                            if(e.$refs.cb)
                                e.$refs.cb.checked = false
                        }

                        if(e.children.length){
                            clear(e.$refs.node)
                        }
                    }
                    
                })
            }
            clear(self.$refs.node)
            
        },


        save: function(ev){
            
           


            var self = this
            
            if(this.bundleName == ''){
                this.showPlaceholder = true
                this.$refs.bName.focus()
                return
            } 

            let toInclude = []

            if(this.isCollab){
                this.$refs.groupMembers.forEach(e => {
                    if(e.firstChild.checked){
                        toInclude.push(parseInt(e.attributes.ci.value))
                    }
                })
            }
            
            this.callBack(this.bundleName, this.collabId, toInclude, this.isCollab, this.selectedId, this.selectedAliasId, this.selectedCollabId, this.doChangeParent)

            setTimeout(function(){
                 self.$emit('close');
            }, 30)
            window.scrollTo(0,0)

            if(this.$parent.$parent.$parent.nextTourStep)
                this.$parent.$parent.$parent.nextTourStep()



        
        },
        cancel: function(){
            this.$emit('close');
        },

        checkInApp: function(){

            if(this.$root.app.userAttrs.bundleLimit > 0 && this.$root.app.checkLimits){
                if(this.$root.app.inApp){
                    this.showCollabAlert = true
                } else {
                    this.$root.app.doShowModal('ModalUpg', {msg: 'collab'})
                }
                this.isCollab = false
                document.getElementById('collabCheckBox').checked = false
            } else {
               this.toggleCollab()
            }
        },

        deleteBundle: async function(){

            let self = this;

            if(this.collabId && !this.aliasTgtId && this.caller.groupMembers.length > 1 && this.caller.data.isRoot){
                //if(await this.$root.app.checkDescendantsForForeign(this.aliasTgtId || this.bundleId)){
                    this.callBack2(true)
                    return
                //}
            }

            if(this.caller.data.id_cog != this.$root.app.userAttrs.sub){
                this.$root.app.showModalOK({message: 'You may not delete a bundle contributed by someone else.'})
                return
            }

            function w(data){
                //remove appropriate tags from cards that are in bundle being deleted (and prob. bundleTags too)
                AZEventBus.$emit('removeBundleFromCardsParents', {id: self.bundleId})

                function findIt(arr){
                    
                    for(var i=0; i < arr.length; i++){
                        let b = arr[i];
    
                        if(b.id == self.bundleId){
                            return i.toString()
                        } else if(b.children.length){
                            let res = findIt(b.children)
                            if(res !== false){
                                return  i + '|' + res
                            } 
                        } else {
                            continue
                        }
                    }
                    return false
                }

                let delPath = findIt(self.$root.app.treeNoInbox).split('|')
    
                if(delPath.length == 1){
                    self.$root.app.treeNoInbox.splice(parseInt(delPath[0]), 1)
                } else {
                    let str = 'self.$root.app.treeNoInbox[' + delPath[0] + ']';
                    for(let i=1; i < delPath.length - 1; i++){
                        str += '.children[' + delPath[i] + ']';
                    }
                    str += '.children.splice(' + delPath[delPath.length -1] + ', 1)'
                
                    eval(str)
                    AZEventBus.$emit('bundleDeleted', {id: self.bundleId})
                }

                let ind = self.$root.app.bundles.findIndex((e) => {
                    return e.id == self.bundleId
                })
                self.$root.app.bundles.splice(ind, 1)

                self.$emit('close')
            }

            function n(){

                self.$emit('close')
            }

            var theKids = []
            function rec(kids){
                kids.forEach(e => {
                    theKids.push(e.id)

                    if(e.children.length){
                        rec(e.children)
                    }
                })
            }

            var bun = self.$root.app.bundles.find(i => {
                return i.id == self.bundleId
            })

            //recurse to get a list of all descendant ids
            rec([bun])

            let bCheck = self.$root.app.bundles.find(e => {
                return e.id == this.bParent
            })

            if(bCheck){
                if(bCheck.aliasTgtId){
                    this.bParent = bCheck.aliasTgtId
                }
            }

            self.$root.app.apiClient.delete('subs/data/bundle', {bundleId: self.bundleId, idList: theKids.toString(), collabId: this.collabId, parentId: this.bParent || null, aliasTgtId: this.aliasTgtId}, w, n);

        },
        bundleFilter: function(){

            if(this.bundleSearchTerm == ''){
                AZEventBus.$emit('collapseTrees', null)
                AZEventBus.$emit('treesCheckIfSelected', null)
                return
            }

            var filteredBundles = []
            
            var filtered = this.$root.app.bundles.filter(e => {
                /* return e.listName.toLowerCase() == this.bundleSearchTerm.toLowerCase() */

                let i = e.listName.toLowerCase().indexOf(this.bundleSearchTerm.toLowerCase().trim())

                if(i == 0) 
                    return true
                else
                    return false
            })

            filtered.forEach(e => {
                filteredBundles.push(e.id)
            })

            AZEventBus.$emit('collapseTrees', null)
            AZEventBus.$emit('filteredBundles', filteredBundles)

        },

        restrictLength: function(e){
            var text = this.bundleName
            if(text.length > 39 && e.key != 'Backspace' && e.key != 'Delete'){
                e.preventDefault()
                this.bundleName = text.substring(0, 40)
            }
            
        },
        createGroup: function(){

            let self = this

            let toInclude = []

            this.err = ''

            this.$refs.groupMembers.forEach(e => {
               if(e.firstChild.checked){
                   toInclude.push(parseInt(e.attributes.ci.value))
               }
            })

            let ind = this.groups.findIndex(e => {
                return e.name == self.$refs.gNameInput.value
            })

            if(ind > -1){
                this.err = 'Group must have unique name.'
                return
            }

            if(this.$refs.gNameInput.value == ''  || toInclude.length == 0 ){
                return
            }

            function w(d){
                if(d.r != 'Failed'){
                    self.groups.unshift({name: self.$refs.gNameInput.value, id: d.r})
                    self.newGroup = false
                    self.collabId = d.r
                    setTimeout(function(){
                        self.$refs.dropdown[1].selected = true
                    }, 30)
                    
                    
                }
            }

            function n(){
                
            }   

            this.$root.app.apiClient.post('subs/data/createaclgroup',{toInclude: toInclude, gName: this.$refs.gNameInput.value }, w, n)
        },
        doNewGroup: function(){
            this.newGroup = true
            let self = this

            function w(d){
                az.addRemSpinner(false, 'id', 'memberList')
                
                let a = d.r.filter(e => {
                    return e.active == 1
                })

                a.sort()
                self.connects = a

            }

            function n(){
                az.addRemSpinner(false, 'id', 'memberList')
            }

            az.addRemSpinner(true, 'id', 'memberList')
            this.$root.app.apiClient.get('subs/conn/', {}, w, n)
        },
        cancelGroup: function(){
            this.err = ''
            this.newGroup = false;
        },
        toggleCollab: function(){

            if(this.isCollab){
                this.tempCollabId = this.collabId
                this.collabId = null
                this.isCollab = false
            } else {
                this.collabId = this.tempCollabId
                this.isCollab = true
            }
            
        }

    },

    computed: {
        filteredTreeNoInbox: function(){

            var arr = this.$root.app.treeNoInbox.slice(0)
            var arr2 = [{listName: 'New Bundle', id: 0, aliasTgtId: 0, children: arr}]
            return arr2

        },
        calcMembers: function(){
            return this.caller.groupMembers.filter(e => {
                return e.active != '33'
            })
        }
    }
     
}

</script>

<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }

    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }

    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }

    input{
        background-color: #333;
        border: none;
        border-bottom: 1px solid #f1c232;
        color: white;
        max-width: 320px
    }

    input::placeholder{
        color: #888
    }
</style>